<template>
  <div class="cart" @click="handleClick">
    <a href="javascript:void(0)">
      <div class="cart-image">
        <NsIcon
          :icon-name="iconName"
          color="#272525"
          size="icon-lg"
          style="width:100%; height:100%"
        />
        <span class="cart-count">{{ countDisplay }}</span>
      </div>
    </a>
  </div>
</template>

<script>
import { NsIcon } from "@nuskin/design-components";
import { CartService } from "@nuskin/ns-shop";
import { events } from "@nuskin/ns-util";

export default {
  name: "NsMiniCartVue",
  components: {
    NsIcon
  },
  props: {
    count: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      localCount: 0
    };
  },
  computed: {
    cartCount() {
      return this.localCount || this.count || 0;
    },
    countDisplay() {
      if (this.cartCount < 1) {
        return "";
      } else if (this.cartCount < 100) {
        return this.cartCount;
      } else {
        return 99;
      }
    },
    iconName() {
      if (this.cartCount < 1) {
        return "icon-largecart-empty";
      } else if (this.cartCount < 100) {
        return "icon-largecart-099";
      } else {
        return "icon-largecart-99p";
      }
    }
  },
  mounted: function() {
    this.setupListener();
  },
  methods: {
    setupListener() {
      let that = this;
      events.subscribe(events.shop.CART_UPDATED, info => {
        if (info && info.cartInfo.qty !== undefined) {
          that.localCount = info.cartInfo.qty > 0 ? info.cartInfo.qty : 0;
        }
      });
      events.getValue(events.global.CS_CONFIG_SET, this.configCallback, true);
    },
    /**
     * The mini-cart was clicked
     */
    handleClick() {
      /**
       * Fired when the mini-cart is clicked: function() => void
       *
       * @type {click}
       */
      this.$emit("mini-cart-click");
      CartService.goToCartPage();
    },

    configCallback(configs) {
      if (
        configs &&
        configs.includes("Url") &&
        configs.includes("Loyalty") &&
        configs.includes("Cart")
      ) {
        events.unsubscribe(events.global.CS_CONFIG_SET, this.configCallback);
        this.localCount = CartService.getCartInfo().qty;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}

.cart {
  position: relative;
  top: 6px;
}
.cart a {
  display: inline-block;
  text-decoration: none !important;
  color: inherit;
}
.cart-count {
  font-size: 14px;
  text-align: center;
  font-weight: 700;
  position: absolute;
  width: 32px;
  height: auto;
  top: -4px;
  right: 0px;
  color: var(--color-primary-text);
}

.cart-image.cart-changed svg {
  animation: cartChanged 0.3s ease-in-out;
}

.cart-image {
  position: relative;
  height: 32px;
  width: 32px;
}

@keyframes cartChanged {
  0% {
    height: 32px;
    top: 0;
  }
  50% {
    height: 36px;
    top: -2px;
  }
  100% {
    height: 32px;
    top: 0;
  }
}
</style>
